
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/come-back-soon",
      function () {
        return require("private-next-pages/come-back-soon/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/come-back-soon"])
      });
    }
  